export default __webpack_public_path__ + "static/media/inferno.82e620c5.png";